import client from './client';

export const getHelpContent = () => client.get('/help-center/content');
export const updateHelpCategory = (id, data) => client.put(`/help-center/categories/${id}`, data);
export const createHelpArticle = (data) => client.post('/help-center/articles', data);
export const updateHelpArticle = (id, data) => client.put(`/help-center/articles/${id}`, data);
export const getHelpTickets = (params) => client.get('/help-center/tickets', { params });
export const getHelpTicket = (id) => client.get(`/help-center/tickets/${id}`);
export const replyHelpTicket = (id, data) => client.post(`/help-center/tickets/${id}/messages`, data);
export const updateHelpTicketStatus = (id, data) => client.put(`/help-center/tickets/${id}/status`, data);
